import { createSelector } from 'reselect';
import DespatchParticularsFormatOfContentsColumns
  from '../../containers/DespatchParticularsFormatOfContentsColumns';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_PARTICULARS_FORMAT_OF_CONTENTS.metadata.generatedOnDateTime;

export const getIsLoading = state => state.reporting.DESPATCH_PARTICULARS_FORMAT_OF_CONTENTS.isLoading;

export const getData = ReportsDefinition.DESPATCH_PARTICULARS_FORMAT_OF_CONTENTS.getDataFunction();

export const getColumns = createSelector(getData, DespatchParticularsFormatOfContentsColumns);
